module.exports = __webpack_public_path__ + "img/close.0e8ddc89.png";